import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { QueryTransactionsArgs, TransactionPage } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryTransactionsArgs;
type TData = TransactionPage;

const MOCK: TVariables = {
  createdAtAfter: undefined,
  createdAtBefore: undefined,
  invoiceId: undefined,
  page: FIRST_PAGE,
  perPage: MAX_PER_PAGE,
  poCode: undefined,
  quality: undefined,
  query: undefined,
  skipPagination: undefined,
  sortAttribute: undefined,
  sortOrder: undefined,
  sourceLanguageCode: undefined,
  targetLanguageCode: undefined,
  transactionType: undefined,
  userId: undefined
};

export const useTransactions = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query transactions(
      $userId: ID
      $invoiceId: ID
      $transactionType: TransactionTypeEnum
      $quality: QualityEnum
      $query: String
      $sourceLanguageCode: String
      $targetLanguageCode: String
      $createdAtAfter: ISO8601DateTime
      $createdAtBefore: ISO8601DateTime
      $sortAttribute: TransactionSortAttributeEnum
      $sortOrder: SortOrderEnum
      $page: Int
      $perPage: Int
      $poCode: String
    ) {
      transactions(
        userId: $userId
        invoiceId: $invoiceId
        transactionType: $transactionType
        quality: $quality
        query: $query
        sourceLanguageCode: $sourceLanguageCode
        targetLanguageCode: $targetLanguageCode
        createdAtAfter: $createdAtAfter
        createdAtBefore: $createdAtBefore
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
        page: $page
        perPage: $perPage
        poCode: $poCode
      ) {
        nodes {
          amount
          createdAt
          currency
          id
          invoiceId
          purchaseOrderCode
          quality
          sourceLanguageCode
          targetLanguageCode
          title
          transactionType
          user {
            name
          }
        }
        nodesCount
        pagesCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['transactions', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      await client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
